<!-- Team -->
<section id="team">
    <div class="team-horizontal">
        <!-- Team Members -->
        <div class="row">
            <div class="wrapper padding-all">
                <div class="section-header inline">
                    <h3 class="letter-spacing">वर्तमान संचालक</h3>
                    <h5 class="letter-spacing">२०२२ - २०२७</h5>
                </div>
            </div>
            <div class="col-md-4 col-sm-12">
                <!-- Team Photo -->
                <div class="team">
                    <div class="team-pic box-custom">
                        <a href="team-detail.html"><img src="https://nmpksbank.in/apis/uploads/1722868768667.png" alt="Team Name" class="img-full"></a>
                    </div>
                    <div class="team-detail">
                        <div class="detail-social">
                            <ul class="social-icons nav-default inline clearfix">
                                <li><a href="#" class="facebook"><i class="fa fa-facebook"></i></a></li>
                                <li><a href="#" class="twitter"><i class="fa fa-twitter"></i></a></li>
                                <li><a href="#" class="google"><i class="fa fa-google-plus"></i></a></li>
                                <li><a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                        <div class="detail-name text-bold"><a href="team-detail.html">श्री. गोविंदा सी. दावळे  </a></div>
                        <div class="detail-title">अध्यक्ष</div>
                    </div>
                </div>
                <!-- Team Photo End -->
            </div>
            <div class="col-md-4 col-sm-12">
                <!-- Team Photo -->
                <div class="team">
                    <div class="team-pic box-custom">
                        <a href="team-detail.html"><img src="https://nmpksbank.in/apis/uploads/1672242923756.png" alt="Team Name" class="img-full"></a>
                    </div>
                    <div class="team-detail">
                        <div class="detail-social">
                            <ul class="social-icons nav-default inline clearfix">
                                <li><a href="#" class="facebook"><i class="fa fa-facebook"></i></a></li>
                                <li><a href="#" class="twitter"><i class="fa fa-twitter"></i></a></li>
                                <li><a href="#" class="google"><i class="fa fa-google-plus"></i></a></li>
                                <li><a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                        <div class="detail-name text-bold"><a href="team-detail.html">श्री. बाबाराव बा. श्रीखंडे </a></div>
                        <div class="detail-title">उपाध्यक्ष</div>
                    </div>
                </div>
                <!-- Team Photo End -->
            </div>
            <div class="col-md-4 col-sm-12">
                <div class="team">
                    <div class="team-pic box-custom">
                        <a href="team-detail.html"><img src="assets/img/ceo.png" alt="Team Name" class="img-full"></a>
                    </div>
                    <div class="team-detail">
                        <div class="detail-social">
                            <ul class="social-icons nav-default inline clearfix">
                                <li><a href="#" class="facebook"><i class="fa fa-facebook"></i></a></li>
                                <li><a href="#" class="twitter"><i class="fa fa-twitter"></i></a></li>
                                <li><a href="#" class="google"><i class="fa fa-google-plus"></i></a></li>
                                <li><a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                        <div class="detail-name text-bold"><a href="team-detail.html">श्री. मनिष के. बोडखे </a></div>
                        <div class="detail-title">मुख्य कार्यकारी अधिकारी </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Team Members End -->
    </div>
    <!-- Section Header -->
    <!-- <div class="box-custom">
        <div class="wrapper padding-all">
            <div class="section-header inline">
                <h2 class="letter-spacing">वर्तमान संचालक</h2>
                <h3 class="letter-spacing">२०१४ - १५ ते २०१९ - २०</h3>
            </div>
        </div>
    </div> -->
    <!-- Section Header End -->
</section>
<!-- Team End -->